// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();

//       this.form = this.querySelector('form');
//       this.form.querySelector('[name=id]').disabled = false;
//       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//       this.submitButton = this.querySelector('[type="submit"]');
//       if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();
//       if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//       this.handleErrorMessage();

//       this.submitButton.setAttribute('aria-disabled', true);
//       this.submitButton.classList.add('loading');
//       this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];

//       const formData = new FormData(this.form);
//       if (this.cart) {
//         formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
//         formData.append('sections_url', window.location.pathname);
//         this.cart.setActiveElement(document.activeElement);
//       }
//       config.body = formData;

//       fetch(`${routes.cart_add_url}`, config)
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             this.handleErrorMessage(response.description);

//             const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//             if (!soldOutMessage) return;
//             this.submitButton.setAttribute('aria-disabled', true);
//             this.submitButton.querySelector('span').classList.add('hidden');
//             soldOutMessage.classList.remove('hidden');
//             this.error = true;
//             return;
//           } else if (!this.cart) {
//             window.location = window.routes.cart_url;
//             return;
//           }

//           if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
//           this.error = false;
//           const quickAddModal = this.closest('quick-add-modal');
//           if (quickAddModal) {
//             document.body.addEventListener('modalClosed', () => {
//               setTimeout(() => { this.cart.renderContents(response) });
//             }, { once: true });
//             quickAddModal.hide(true);
//           } else {
//             this.cart.renderContents(response);
//           }
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           this.submitButton.classList.remove('loading');
//           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner').classList.add('hidden');
//         });
//     }

//     handleErrorMessage(errorMessage = false) {
//       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//       if (!this.errorMessageWrapper) return;
//       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//       if (errorMessage) {
//         this.errorMessage.textContent = errorMessage;
//       }
//     }
//   });
// }


// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();
//       this.form = this.querySelector('form');
//       this.form.querySelector('[name=id]').disabled = false;
//       this.submitButton = this.querySelector('[type="submit"]');
//       this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//       if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
//       this.initializeDynamicProperties();
//     }

//     initializeDynamicProperties() {
//       const sections = document.querySelectorAll('.form-section');
//       if (!sections.length) return;
//       sections.forEach(section => {
//         const inputs = section.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]');
//         if (!inputs.length) return;

//         inputs.forEach(input => {
//           const propertyName = input.name.replace(/^properties\[|\]$/g, '');
//           let hidden = this.form.querySelector(`input[type="hidden"][name="properties[${propertyName}]"]`);
//           if (!hidden) {
//             hidden = document.createElement('input');
//             hidden.type = 'hidden';
//             hidden.name = `properties[${propertyName}]`;
//             this.form.appendChild(hidden);
//           }

//           const updateHiddenInput = () => {
//             const label = input.closest('label');
//             const isDisabled = label && label.classList.contains('is-disabled');
//             const isChecked = input.type === 'checkbox' || input.type === 'radio' ? input.checked : true;
//             if (!isChecked || isDisabled || !input.closest('.input-checked-css-class')) {
//               hidden.value = '';
//               hidden.disabled = true;
//               return;
//             }

//             let value = '';
//             if (input.type === 'checkbox') {
//               const checked = section.querySelectorAll(`input[name="${input.name}"]:checked`);
//               value = Array.from(checked).map(cb => cb.value).join(', ');
//             } else if (input.type === 'radio') {
//               const checked = section.querySelector(`input[name="${input.name}"]:checked`);
//               value = checked ? checked.value : '';
//             } else if (input.tagName === 'SELECT') {
//               value = input.value || '';
//             } else {
//               value = input.value.trim();
//             }
//             hidden.value = value;
//             hidden.disabled = !(value && value !== '');
//           };

//           if (input.type === 'checkbox' && input.value === 'All of the Above') {
//             input.addEventListener('change', () => {
//               const group = section.querySelectorAll(`input[type="checkbox"][name="${input.name}"]:not([value="All of the Above"])`);
//               const allChecked = input.checked;
//               group.forEach(cb => { if (cb.checked !== allChecked) cb.click(); });
//             });
//           }

//           if (input.type === 'checkbox' && input.value !== 'All of the Above') {
//             input.addEventListener('change', () => {
//               const allAbove = section.querySelector(`input[type="checkbox"][name="${input.name}"][value="All of the Above"]`);
//               if (allAbove) {
//                 const group = section.querySelectorAll(`input[type="checkbox"][name="${input.name}"]:not([value="All of the Above"])`);
//                 const allChecked = Array.from(group).every(cb => cb.checked);
//                 allAbove.checked = allChecked;
//               }
//               updateHiddenInput();
//             });
//           }

//           input.addEventListener('change', updateHiddenInput);
//           input.addEventListener('input', updateHiddenInput);
//           updateHiddenInput();
//         });
//       });
//     }

//     appendCustomProperties() {
//       const hiddenInputs = this.form.querySelectorAll('input[type="hidden"][name^="properties["]');
//       hiddenInputs.forEach(input => {
//         if (!input.value || input.disabled) {
//           input.remove();
//         }
//       });
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();
//       if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
//       this.appendCustomProperties();
//       this.submitButton.setAttribute('aria-disabled', true);
//       this.submitButton.classList.add('loading');
//       const formData = new FormData(this.form);
//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];
//       config.body = formData;

//       if (this.cart) {
//         formData.append('sections', this.cart.getSectionsToRender().map(s => s.id));
//         formData.append('sections_url', window.location.pathname);
//         this.cart.setActiveElement(document.activeElement);
//       }

//       fetch(`${routes.cart_add_url}`, config)
//         .then(r => r.json())
//         .then(response => {
//           if (response.status) return;
//           if (this.cart) this.cart.renderContents(response);
//         })
//         .finally(() => {
//           this.submitButton.classList.remove('loading');
//           this.submitButton.removeAttribute('aria-disabled');
//         });
//     }
//   });
// }





if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.initializeDynamicInputs();
    }

// initializeDynamicInputs() {
//   const section = document.querySelector('.custom-main-form-section');
//   if (!section) return;

//   const allInputs = section.querySelectorAll('input[type="checkbox"], select, input[type="text"]');

//   // Helper function to update hidden input for a checkbox group
//   const updateCheckboxGroup = (groupName) => {
//     const checkboxes = section.querySelectorAll(`input[name="${groupName}"]`);
//     const enabledChecked = Array.from(checkboxes).filter(cb => {
//       const label = cb.closest('label');
//       if (!label) return true;
//       const style = window.getComputedStyle(label);
//       return cb.checked && !label.classList.contains('is-disabled') && style.pointerEvents !== 'none';
//     });

//     const combinedValue = enabledChecked.map(cb => cb.value).join(',');
//     const existingClone = this.form.querySelector(`input[data-clone-of="${groupName}"]`);
//     if (existingClone) existingClone.remove();
//     if (combinedValue) {
//       const clone = document.createElement('input');
//       clone.type = 'hidden';
//       clone.name = groupName;
//       clone.value = combinedValue;
//       clone.setAttribute('data-clone-of', groupName);
//       this.form.appendChild(clone);
//     }
//   };

//   allInputs.forEach(input => {
//     if (input.tagName === 'INPUT' && input.type === 'checkbox') {
//       // Observe label class/style changes
//       const label = input.closest('label');
//       if (label) {
//         const observer = new MutationObserver(() => updateCheckboxGroup(input.name));
//         observer.observe(label, { attributes: true, attributeFilter: ['class', 'style'] });
//       }

//       // Listen to change event
//       input.addEventListener('change', () => updateCheckboxGroup(input.name));

//       // Initialize
//       updateCheckboxGroup(input.name);
//     }

//     // Select handling
//     if (input.tagName === 'SELECT') {
//       const updateSelect = () => {
//         const existingClone = this.form.querySelector(`input[data-clone-of="${input.name}"]`);
//         if (existingClone) existingClone.remove();
//         if (input.value) {
//           const clone = document.createElement('input');
//           clone.type = 'hidden';
//           clone.name = input.name;
//           clone.value = input.value;
//           clone.setAttribute('data-clone-of', input.name);
//           this.form.appendChild(clone);
//         }
//       };
//       input.addEventListener('input', updateSelect);
//       input.addEventListener('change', updateSelect);
//       updateSelect();
//     }
//     // --- SPECIAL HANDLING FOR "All of the Above" --------
// if (input.tagName === 'INPUT' && input.type === 'checkbox' && input.getAttribute('handle-value') === 'all-of-the-above') {

//   input.addEventListener('change', () => {

//     const groupName = input.name;
//     const checkboxes = section.querySelectorAll(`input[name="${groupName}"]`);

//     if (input.checked) {
//       // 1) SAB check karo
//       checkboxes.forEach(cb => {
//         if (!cb.closest('label').classList.contains('is-disabled')) {
//           cb.checked = true;
//         }
//       });
//     } else {
//       // 2) SAB uncheck karo
//       checkboxes.forEach(cb => {
//         cb.checked = false;
//       });
//     }

//     // 3) Ab hidden input update kara do
//     updateCheckboxGroup(groupName);

//   });
// }


//     // Text input handling
//     if (input.tagName === 'INPUT' && input.type === 'text') {
//       const updateText = () => {
//         const existingClone = this.form.querySelector(`input[data-clone-of="${input.name}"]`);
//         if (existingClone) existingClone.remove();
//         if (input.value.trim()) {
//           const clone = document.createElement('input');
//           clone.type = 'hidden';
//           clone.name = input.name;
//           clone.value = input.value.trim();
//           clone.setAttribute('data-clone-of', input.name);
//           this.form.appendChild(clone);
//         }
//       };
//       input.addEventListener('input', updateText);
//       input.addEventListener('change', updateText);
//       updateText();
//     }
//   });
// }

    initializeDynamicInputs() {
      const section = document.querySelector('.custom-main-form-section');
      if (!section) return;

      const allInputs = section.querySelectorAll(
        'input[type="checkbox"], input[type="radio"], select, input[type="text"]'
      );

      // ---------- CHECKBOX GROUP ----------
      const updateCheckboxGroup = (groupName) => {
        const checkboxes = section.querySelectorAll(`input[name="${groupName}"]`);

        const enabledChecked = Array.from(checkboxes).filter(cb => {
          const label = cb.closest('label');
          if (!label) return cb.checked;
          const style = window.getComputedStyle(label);
          return cb.checked && !label.classList.contains('is-disabled') && style.pointerEvents !== 'none';
        });

        const combinedValue = enabledChecked.map(cb => cb.value).join(',');

        const existingClone = this.form.querySelector(`input[data-clone-of="${groupName}"]`);
        if (existingClone) existingClone.remove();

        if (combinedValue) {
          const clone = document.createElement('input');
          clone.type = 'hidden';
          clone.name = groupName;
          clone.value = combinedValue;
          clone.setAttribute('data-clone-of', groupName);
          this.form.appendChild(clone);
        }
      };

      // ---------- RADIO ----------
      const updateRadioGroup = (groupName) => {
        const selected = section.querySelector(`input[type="radio"][name="${groupName}"]:checked`);

        const existingClone = this.form.querySelector(`input[data-clone-of="${groupName}"]`);
        if (existingClone) existingClone.remove();

        if (selected) {
          const clone = document.createElement('input');
          clone.type = 'hidden';
          clone.name = groupName;
          clone.value = selected.value;
          clone.setAttribute('data-clone-of', groupName);
          this.form.appendChild(clone);
        }
      };

      allInputs.forEach(input => {

        // ---------- CHECKBOX ----------
        if (input.type === 'checkbox') {
          const label = input.closest('label');
          if (label) {
            const observer = new MutationObserver(() => updateCheckboxGroup(input.name));
            observer.observe(label, { attributes: true, attributeFilter: ['class', 'style'] });
          }

          input.addEventListener('change', () => updateCheckboxGroup(input.name));
          updateCheckboxGroup(input.name);
        }

        // ---------- RADIO ----------
        if (input.type === 'radio') {
          input.addEventListener('change', () => updateRadioGroup(input.name));
          updateRadioGroup(input.name);
        }

        // ---------- SELECT ----------
        if (input.tagName === 'SELECT') {
          const updateSelect = () => {
            const existingClone = this.form.querySelector(`input[data-clone-of="${input.name}"]`);
            if (existingClone) existingClone.remove();

            if (input.value) {
              const clone = document.createElement('input');
              clone.type = 'hidden';
              clone.name = input.name;
              clone.value = input.value;
              clone.setAttribute('data-clone-of', input.name);
              this.form.appendChild(clone);
            }
          };

          input.addEventListener('change', updateSelect);
          updateSelect();
        }

        // ---------- TEXT ----------
        if (input.type === 'text') {
          const updateText = () => {
            const existingClone = this.form.querySelector(`input[data-clone-of="${input.name}"]`);
            if (existingClone) existingClone.remove();

            if (input.value.trim()) {
              const clone = document.createElement('input');
              clone.type = 'hidden';
              clone.name = input.name;
              clone.value = input.value.trim();
              clone.setAttribute('data-clone-of', input.name);
              this.form.appendChild(clone);
            }
          };

          input.addEventListener('input', updateText);
          updateText();
        }
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}


